const education = [
    {
        key: 1,
        img: "./buse.png",
        name: "Bindura University of Science Education",
        duration: "August 2019 - June 2023",
        education: "Information Technology",
        degree: "Bachelor of Software Engineering",
    },
]


export default education